import { SessionStorageKeys } from '@/utils/storage';

// Allowlist, not a denylist: only these keys are ever attached to a Sentry
// event's `extra.sessionStorage`. A new SessionStorageKeys member is invisible
// to Sentry until someone deliberately adds it here — the opposite of a
// denylist, where every new key leaks by default.
//
// These are the operational keys the team actually debugs with. Notably
// absent: SessionStorageKeys.RESIDENCY. The candidate's California/Illinois
// residency declaration is biometric-adjacent state-privacy data (BIPA/CCPA)
// and must never leave the browser via telemetry, even keyed to an
// identifiable candidate via Sentry.setUser. Do not add it back "for
// completeness" — that's exactly the mistake this allowlist exists to
// prevent.
const SENTRY_SESSION_STORAGE_ALLOWLIST: SessionStorageKeys[] = [
  SessionStorageKeys.INVITATION_KEY,
  SessionStorageKeys.SELECTED_LANGUAGE,
  SessionStorageKeys.INTERVIEW_LANGUAGE,
  SessionStorageKeys.CURRENT_QUESTION_NUMBER,
];

/**
 * Reads the current `sessionStorage` and returns only the allowlisted
 * key/value pairs, suitable for attaching as `event.extra.sessionStorage`
 * in a Sentry `beforeSend` hook.
 *
 * Keys missing from storage are omitted entirely (never reported as
 * `undefined`).
 */
export function getSessionStorageSnapshot(): Record<string, string | null> {
  const snapshot: Record<string, string | null> = {};

  for (const key of SENTRY_SESSION_STORAGE_ALLOWLIST) {
    const value = sessionStorage.getItem(key);
    if (value !== null) {
      snapshot[key] = value;
    }
  }

  return snapshot;
}
